export const GET_EXPORTED_XEROS = 'GET_EXPORTED_XEROS'
export const GET_EXPORTED_XEROS_SUCCESS = 'GET_EXPORTED_XEROS_SUCCESS'
